// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"loader_loader-wrapper__7-L0r","loader":"loader_loader__QZXb2","l17":"loader_l17__p-vNF"};